// India-focused vehicle Make -> Model dataset for used / scrap vehicle sourcing.
// Structured so new Makes/Models can be added or edited later without code changes.
// To add: append a make to VEHICLE_MAKES and add its models in MODELS_BY_MAKE.

export const MODELS_BY_MAKE = {
  "Maruti Suzuki": [
    "Alto", "Alto 800", "Alto K10", "WagonR", "Swift", "Swift Dzire", "Dzire",
    "Baleno", "Celerio", "Ritz", "Zen", "Zen Estilo", "A-Star", "Eeco", "Omni",
    "Ertiga", "Vitara Brezza", "Brezza", "S-Cross", "Ciaz", "S-Presso", "Ignis",
    "XL6", "Grand Vitara", "Fronx", "Jimny", "Gypsy", "SX4", "Esteem", "800", "Versa",
  ],
  Hyundai: [
    "Santro", "Santro Xing", "i10", "Grand i10", "Grand i10 Nios", "i20", "Elite i20",
    "i20 Active", "Xcent", "Aura", "Accent", "Verna", "Fluidic Verna", "Elantra",
    "Creta", "Venue", "Venue N Line", "Alcazar", "Tucson", "Kona Electric", "Getz",
    "Eon", "Sonata", "Santa Fe", "Exter",
  ],
  Tata: [
    "Indica", "Indica Vista", "Indigo", "Indigo CS", "Nano", "Bolt", "Zest", "Tiago",
    "Tigor", "Altroz", "Punch", "Nexon", "Nexon EV", "Harrier", "Safari", "Safari Storme",
    "Hexa", "Aria", "Sumo", "Sumo Gold", "Sumo Victa", "Winger", "Manza", "Xenon", "Curvv",
  ],
  Mahindra: [
    "Bolero", "Bolero Neo", "Bolero Pik-Up", "Scorpio", "Scorpio-N", "Scorpio Classic",
    "XUV300", "XUV400", "XUV500", "XUV700", "Thar", "TUV300", "Marazzo", "KUV100",
    "Xylo", "Verito", "Verito Vibe", "Quanto", "Logan", "Alturas G4",
  ],
  Honda: [
    "City", "Amaze", "Jazz", "Brio", "WR-V", "BR-V", "Civic", "Accord", "CR-V",
    "Mobilio", "Elevate", "City Hybrid",
  ],
  Toyota: [
    "Innova", "Innova Crysta", "Innova Hycross", "Fortuner", "Etios", "Etios Liva",
    "Corolla", "Corolla Altis", "Camry", "Qualis", "Yaris", "Glanza", "Urban Cruiser",
    "Urban Cruiser Hyryder", "Rumion", "Land Cruiser", "Hilux",
  ],
  Kia: ["Seltos", "Sonet", "Carens", "Carnival", "EV6"],
  Renault: [
    "Kwid", "Duster", "Triber", "Kiger", "Lodgy", "Pulse", "Scala", "Fluence",
    "Koleos", "Captur",
  ],
  Volkswagen: ["Polo", "Vento", "Ameo", "Virtus", "Taigun", "Tiguan", "Passat", "Jetta", "Beetle"],
  Skoda: ["Fabia", "Rapid", "Octavia", "Superb", "Kushaq", "Slavia", "Kodiaq", "Laura", "Yeti"],
  MG: ["Hector", "Hector Plus", "Astor", "Gloster", "ZS EV", "Comet EV"],
  Nissan: ["Micra", "Sunny", "Terrano", "Kicks", "Magnite", "GT-R"],
  Ford: ["Figo", "Figo Aspire", "Aspire", "EcoSport", "Endeavour", "Fiesta", "Ikon", "Freestyle", "Classic"],
  Chevrolet: ["Beat", "Spark", "Sail", "Aveo", "Cruze", "Tavera", "Enjoy", "Optra", "Captiva"],
  Datsun: ["GO", "GO+", "redi-GO"],
  Fiat: ["Punto", "Grande Punto", "Linea", "Palio", "Avventura"],
  Jeep: ["Compass", "Meridian", "Wrangler"],
  Isuzu: ["D-Max", "D-Max V-Cross", "MU-X"],
  Force: ["Gurkha", "Trax", "Traveller"],
  "Mercedes-Benz": ["A-Class", "C-Class", "E-Class", "S-Class", "GLA", "GLC", "GLE"],
  BMW: ["1 Series", "3 Series", "5 Series", "7 Series", "X1", "X3", "X5"],
  Audi: ["A3", "A4", "A6", "Q3", "Q5", "Q7"],
  Other: [],
};

// Ordered by popularity for the default (unsearched) scroll list.
export const VEHICLE_MAKES = Object.keys(MODELS_BY_MAKE);

export function getModelsForMake(make) {
  if (!make) return [];
  return MODELS_BY_MAKE[make] || [];
}
